import { Expose } from "class-transformer";
import type { NegativeFeedbackReasonEnum } from "../enums/negative-feedback-reason.enum";

export interface IUpdateMessageNegativeFeedbackReasonDto {
  negativeFeedbackReason: NegativeFeedbackReasonEnum;
}

export class UpdateMessageNegativeFeedbackReasonDto implements IUpdateMessageNegativeFeedbackReasonDto {
  constructor(data?: IUpdateMessageNegativeFeedbackReasonDto) {
    if (data) {
      this.negativeFeedbackReason = data.negativeFeedbackReason;
    }
  }

  @Expose()
  negativeFeedbackReason!: NegativeFeedbackReasonEnum;
}
